import { Observable, of as observableOf, Subject } from 'rxjs';

import { map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserProfile } from '../../lib/classes/userProfile';
import { User } from '../../lib/classes/user';
import { RequestService } from '../../lib/services';
import { Unit } from '../models/unit';
import { Page } from '../../lib/classes/page';
import { UnitEmployment } from '../models/unitEmployment';

@Injectable()
export class UnitService {
  constructor(private http: HttpClient) {}

  private _companyApiEndpoint = environment.apiUrl + ''; // URL to web api
  private _userApiEndpoint = environment.apiUrl + 'users/'; // URL to web api

  public createUnitForInvite(
    office_id: number,
    position: string,
    user: User,
    company_id: number
  ) {
    user.user_profile = <UserProfile>{};
    const body = JSON.stringify({
      unit: {
        office: office_id,
        company: String(company_id),
        position: position,
        user: String(user.id),
      },
    });

    return this.http.post<Unit>(
      this._companyApiEndpoint + office_id + 'units/',
      body
    );
  }

  public getUnits() {
    return this.http.get<Page<Unit>>(this._companyApiEndpoint + 'units/');
  }

  public getUnitsTree(id) {
    return this.http.get<any>(
      this._companyApiEndpoint + 'units/' + id + '/tree/'
    );
  }

  // public getUnits() {
  //   return this.http.get<Page<Unit>>(this._companyApiEndpoint + 'units/current-user/employments');
  // }

  public getUnit(unit_id: number) {
    // tslint:disable-next-line:max-line-length
    return this.http.get<Unit>(
      this._companyApiEndpoint + 'units/' + unit_id + '/'
    );
  }

  // public getUnitPendingInvite(office_id: number) {
  //     return this.http.get<UnitInvite[]>(this._companyApiEndpoint + office_id + '/invitations/');
  // }

  public deleteUnitInviteById(office_id: number, invite_id: number) {
    return this.http.delete(
      this._companyApiEndpoint + office_id + '/invitations/' + invite_id + '/'
    );
  }

  public deleteUnit(unit_id: number) {
    return this.http.delete(
      this._companyApiEndpoint + 'units/' + unit_id + '/'
    );
  }

  public updateUnit(unit) {
    const body = JSON.stringify(unit);
    return (
      this.http
        // tslint:disable-next-line:max-line-length
        .put<Unit>(this._companyApiEndpoint + 'units/' + unit.id + '/', body)
    );
  }

  public updateUnitEmployment(unitEmployment: UnitEmployment) {
    const body = JSON.stringify(unitEmployment);
    return this.http.put<UnitEmployment>(
      this._companyApiEndpoint +
        'units/' +
        unitEmployment.unit.id +
        '/employments/' +
        unitEmployment.id +
        '/',
      body
    );
  }

  public deleteUnitEmployment(unitEmployment: UnitEmployment) {
    const body = JSON.stringify(unitEmployment);
    return this.http.delete(
      this._companyApiEndpoint +
        'units/' +
        unitEmployment.unit.id +
        '/employments/' +
        unitEmployment.id +
        '/'
    );
  }

  public moveUnit(
    old_office_id: number,
    new_office_id: number,
    unit_id: number
  ) {
    return this.http.put<Unit>(
      this._companyApiEndpoint +
        old_office_id +
        'units/' +
        unit_id +
        '/move-to-office/' +
        new_office_id +
        '/',
      {}
    );
  }

  public getUserUnits() {
    return this.http.get<Unit[]>(this._userApiEndpoint + 'current-userunits/');
  }

  public getUnitUsers(id) {
    return this.http.get<Page<{}>>(
      this._companyApiEndpoint + 'units/' + id + '/employments/'
    );
  }

  public postUsers(id, body) {
    return this.http.post(
      this._companyApiEndpoint + 'units/' + id + '/employments/',
      body
    );
  }

  public resendInvitation(unitId, userId) {
    return this.http.post(
      this._companyApiEndpoint +
        'units/' +
        unitId +
        '/employments/' +
        userId +
        '/resend-invitation/',
      {}
    );
  }

  public addSubUnit(body) {
    return this.http.post(this._companyApiEndpoint + 'units/', body);
  }

  public editSubUnit(body) {
    return this.http.put(this._companyApiEndpoint + 'units/', body);
  }
}
